import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'

const MonitorPerformanceDashboard = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      This page breaks down the test cases in your selected monitor configuration, showing the run time data of it's test case steps over a specified period.
    </Color>
  </Paragraph>

export default MonitorPerformanceDashboard
